package org.example.garfend.util

object Constants {

    const val SECTION_WIDTH = 1920
    val FONT_FAMILY = arrayOf("Inter", "sans-serif")

    val listOfJobs = listOf(
        "Developing innovative user-centered mobile applications. \n" +
                " With expertise in Mobile development using Kotlin and Java for Android, \n" +
                " and Flutter for cross-platform.",

        "Building and maintaining scalable, high-performance mobile apps using Flutter framework.\n",

        "intense training in android frameworks such as kotlin, xml, jetpack compose and cmp.\n" +
                "building android projects from scratch using various techs in the process.",

        "comprehensive training in program in Frontend and Cross-Platform development.\n" +
                "using React, Next, React Native for Front end and cross-platform development java based.\n" +
                "using Flutter framework and Dart programming language for mobile app development.\n",

        "Developed advanced Android apps using Kotlin and jetpack compose, \n" +
                "Demonstrated proficiency in Android frameworks \n" +
                "Applied development best practices \n" +
                "and applying clean code and clean architecture\n"
    )
    
    const val ANDROID_DEV ="building scalable, high-performance mobile apps using Kotlin, Java, and Flutter. From concept to deployment, I deliver robust solutions tailored to your needs."
    const val UI_UX ="creating user-friendly, visually stunning interfaces for Android and iOS apps. My designs focus on functionality, aesthetics, and exceptional user experiences."
    const val MOBILE_DEV ="creating seamless, cross-platform mobile experiences using Flutter. From UI/UX design to backend integration, I ensure your app stands out in the competitive market."
    const val  ABOUT_ME_INFO = "Hello, I am Abdelrahman Abdelwahab, I am a Mobile App Developer with a strong background in creating innovative, user-centered mobile applications. With expertise in Mobile development using Kotlin and Java for Android, and Flutter for cross-platform, I build apps that are not only just functional but also visually engaging and responsive, Full project management from start to finish, Regular communication is important to me, so let’s keep in touch."

    const val CONTACT_PHONE = "+201009483273"
    const val CONTACT_EMAIL = "abdelrahmanabdelwahab1090@gmail.com"
    const val devName = "Abdelrahman Abdelwahab"
    const val projectsCompleted = "10"
    const val YOE = "3"
    const val trainingPrograms = "5"
    const val happyClients = "7"
}

object Res {
    object Icon {
        const val web = "/web_icon.svg"
        const val design = "/design_icon.svg"
        const val apple = "/apple_icon.svg"
        const val android = "/android_icon.svg"
        const val link = "/link_icon.svg"
        const val user = "/user_icon.svg"
        const val shield = "/shield_icon.svg"
        const val happy = "/happy_icon.svg"
        const val checkmark = "/checkmark_icon.svg"
        const val flutter = "/flutter.svg"

    }
    object Image {
        const val background = "/background.svg"
        const val musemagic = "/musemagic.png"
        const val fromscratch = "/fromscratch.png"
        const val dawaalink = "/dawaalink.png"
        const val dawaalink2 = "/dawaalink2.png"
        const val titanumgym = "/titanumgym.png"
        const val dabdoub = "/dabdoub.png"
        const val orderk =  "/orderk.png"
        const val serineKamal = "/serinekamal.jpeg"
        const val mabooks = "/mabooks_logo.png"
        const val orderkshop = "/orderkshop_logo.png"
        const val nourishdurham = "/nourishdurham.png"
        const val topmedia = "/topmedia.png"
        // Current OrderkShop brand mark (cart + pin), shared by the storefront and the driver app —
        // the driver app has no artwork of its own, it still ships the GroFresh template icon.
        const val orderkshopIcon = "/orderkshop_icon.png"

    }
}
